import { Expose, Transform } from "class-transformer";
import { WorkStatusEnum } from "@altertec_gparn/lib";
import { parseBooleanOptionValue } from "@/utils/parse-boolean-option-value";

export class CreateWorkTaskDto {
  @Expose()
  status: WorkStatusEnum;

  @Expose()
  pendingWork: string;

  @Expose()
  assetId?: string;

  @Expose()
  @Transform(({ value }) => parseBooleanOptionValue(value))
  rotorLock?: boolean | null;
}
